const filterOutDuplicatedItems = (items) => {
  const uniqueItems = new Map(items.map((item) => [item.id, item]));

  return Array.from(uniqueItems.values());
};

export default filterOutDuplicatedItems;
